/**
 ** 2016-11-21 zhangmyh
 * 添加componentWillReceiveProps和componentDidUpdate事件处理，在viewmodel更新时，更新viewmodel监听
 * 这样改动主要为了在设置表格标题之后，刷新表格内容，并重新关联viewmodel，使columnSetting按钮可用
 */
//FLH 2D Move 2D Table To YXYWeb
import React from 'react';
import { findDOMNode } from 'react-dom';
import { Table, Column, Cell, ColumnGroup } from 'fixed-data-table-2';
import { Checkbox, Pagination, Popover, Select, Button, Input, Icon } from 'antd';
import Row from './row';
import Col from './col';
import GridFilterModel from '../grid/GridFilterModel';
import CellModel from '../grid/CellModel';
import addEventListener from 'rc-util/lib/Dom/addEventListener';
import { getPredicateValue, getRoundValue, getMultiplication } from '../../helpers/util'
import SvgIcon from 'SvgIcon';
import * as PopoverMap from '../../../../common/components/popover';
import { uniqueId, findIndex, findLastIndex, cloneDeep } from 'lodash';
// import HotAreaMapDesign from '../meta/HotAreaMapDesign'
// import HotAreaMapDisplay from '../meta/HotAreaMapDisplay'
// import ListAreaMap from '../meta/ListAreaMap'
// import HotAreaMapDesignContainer from '../modal/HotAreaMapDesignContainer'
const Search = Input.Search;
let Sortable = null;
if (process.env.__CLIENT__) Sortable = require('react-sortablejs');
export default class FixedDataTableControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      readOnly: true,//是否只读
      visible: false,
      pagination: { total: 0, current: 0, pageSize: 0 },
      sumData: [],//合计数据
      containers: props.containers,
      style: props.style,
      mergeCells: this.props.mergeCells || false,
      mergePosition: 'center',
      popFlag: false,
      titleList: [],
      searchValue: "",
      lockSort: null,
      showAction: [],
      lookUpRowIndexes: [],
      lookUpRow: -1,
      Unlock: false,
      lockindex: -1,
      sorttag: null,
      editag: false,
      searchtag: false,
      subtotalData: {},
      autoHeight: props.autoHeight,
      isClear: false,
      bPaste: (props.style && props.style.bPaste) || false, /* 是否允许粘贴excel */
    };
    // showCheckBox 是否显示选择框  showRowNo 是否显示行号 showAggregates 是否显示合计小计 isRadio 是否单选 isPagination 是否分页
    this.GridProps = {
      showCheckBox: false, showRowNo: false, showAggregates: true, showSubtotal: false, isRadio: true, isPagination: false,
    };
    this.dataList = [];/*grid数据*/   this.columns = {};/*grid栏目数据*/  this.ColIndexs = {};/*key与number对照*/
    this.selectIndex = -1;/*选择行index*/ this.scrollCol = null; this.scrollRow = 0; this.CellStatus = [];//单元格是否编辑状态
    this.rowStatus = [];/*行状态*/ this.allSelect = false; this.isExpanded = false; /*是否可展开*/
    this.headerHeight = 30; this.actionState = {}; this.indeterminate = false; /*全选框选中但未全选样式*/
    this.CellState = [];/*单元格状态 disabled readnonly style*/  this.isColErro = [];
    this.CompositeLayout = []; this.action = {};/*操作列渲染数据*/ this.hasAction = false; this.hoverRow = 0; this.actionStyle = {};
    this.compositeControl = {};/*组合控件元数据存储*/  this.RowCol = {};/*记录RowColChange改变前数据*/
    this.sort = ""; this.showActionIndex = -1; this.sortColumn = '';
    this.rowheight = 35; this.scrollEndHeight = 0;
    this.mergeColContrast = {};
    this.lookUpRowIndexes = []; this.lookUpRow = -1; this.lookUpKey = '';
    this.lockstate = ''; this.columnlock = []; this.unlockstate = false; this.dragList = []
  }
  resetCellStatus = () => {
    this.cellState = []; this.isColErro = []; this.CellStatus = [];
    this.rowStatus = []; this.actionState = {};
  }
  setTable2DSum() {
    let model = this.props.model;
    let sumData = model && model.getCache("table2DSum");
    if (sumData && _.isEqual(sumData, this.state.sumData) == false) {
      this.setState({
        sumData
      })
    }
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
    this.setTable2DSum();
    const uuid = new Date().valueOf();
    this.tableGuid = uuid;
    this.keydownHandler = addEventListener(document, 'keydown', e => this._handleKeyDown(e, uuid));
    this.mousedownHandler = addEventListener(document, 'mousedown', this._DocumentMouseDown);
    this.pasteHandler = addEventListener(document, 'paste', e => this._handlePaste(e, uuid));
    if (this.refs.fixedtable)
      this.fixedTable = this.refs.fixedtable;
  }

  componentWillUpdate() {
    this.setTable2DSum();
  }

  // componentDidUpdate() {
  //   if (this.props.model)
  //     this.props.model.addListener(this);
  // }
  componentWillReceiveProps(nextProps) {
    if (nextProps.model != this.props.model) {
      if (this.props.model) this.props.model.removeListener(this)
      if (nextProps.model) nextProps.model.addListener(this);
    }
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
    this.keydownHandler.remove();
    this.keydownHandler = null;
    this.mousedownHandler.remove();
    this.mousedownHandler = null;
    this.pasteHandler.remove();
    this.pasteHandler = null;
  }

  rowClassNameGetter = (index) => {
    if (this.rowStatus[index] && this.rowStatus[index].disabled && this.rowStatus[index].disabled != undefined) {
      return 'public_fixedDataTableRow_disabled';
    }
    if (this.rowStatus[index] && this.rowStatus[index].className && this.rowStatus[index].disabled != undefined) {
      return 'public_fixedDataTableRow_' + this.rowStatus[index].className;
    }

    /*add by jinzh1 查找功能row*/
    let lookUpRowIndexes = this.lookUpRowIndexes;
    if (lookUpRowIndexes.length > 0) {
      let className = '';
      for (let i = 0; i < lookUpRowIndexes.length; i++) {
        if (index == lookUpRowIndexes[i]) {
          className = 'public_fixedDataTableRow_LookUpRow';
          break;
        }
      }
      for (let i = 0; i < lookUpRowIndexes.length; i++) {
        if (index == this.lookUpRow) {
          className = className + ' public_fixedDataTableRow_LookUpRow_Focused';
          break;
        }
      }
      if (className != '') return className;
    }

    // if (this.props.model && !this.GridProps.showCheckBox && !this.state.readOnly) {
    if (this.props.model) {
      let selectRows = this.props.model.getSelectedRowIndexes();
      let keyboardIndex = this.props.model._get_data('keyboardIndex');
      keyboardIndex = keyboardIndex === undefined ? -1 : keyboardIndex;
      let _class = '';
      if (keyboardIndex >= 0 && keyboardIndex === index)
        _class += ' public_fixedDataTableRow_preFocusedRow'; 
      for (let i = 0; i < selectRows.length; i++) {
        let rowIndex = selectRows[i];
        if (index === rowIndex)
          _class += ' public_fixedDataTableRow_CheckedRow';
      }
      if (_class) return _class
    }
    if (!this.isExpanded) {
      if (index === this.selectIndex)
        return 'public_fixedDataTableRow_selected';
      return;
    }
    if (index % 2 === 1)
      return 'public_fixedDataTableRow_expanded';
    if (index === this.selectIndex)
      return 'public_fixedDataTableRow_selected';
  }
  //鼠标点击事件
  _DocumentMouseDown = (e) => {
    let p1 = cb.dom(event.target).parents('.columnSetting');
    let p2 = cb.dom(event.target).parents('.ant-popover');
    if (p1.length == 0 && p2.length == 0 && this.state.popFlag) {
      this.setState({
        popFlag: false
      });
    }

  }
  //捕捉键盘事件
  _handleKeyDown = (e, uuid) => {
    let self = this;
    switch (e.keyCode) {
      case 13://回车
        let activeDom = cb.dom(e.target);
        const id = activeDom.parents('.meta-table').length > 0 ? activeDom.parents('.meta-table')[0].id : this.tableGuid;
        if (id != uuid) return;
        if (activeDom.parents('.pagination-new').length > 0) return;
        if (e.target.className.indexOf('meta-table') > 0 || activeDom.parents('.meta-table').length > 0 || activeDom.parents('.refer-div').length > 0 || activeDom[0].nodeName == 'BODY') {
          if (!activeDom.parents('.refer-div')[0] || !activeDom.parents('.refer-div')[0].parentElement)
            self.switchCell();
        }
    }
  }

  // 粘贴事件
  _handlePaste = (e, uuid) => {
    if (!this.state.bPaste) return;
    if (e.target.type === 'search') return;// 处理参中使用拷贝报错问题
    let activeDom = cb.dom(e.target);
    if (activeDom.parents('.filter-controls').length > 0) return;
    if (activeDom.parents('.referModal').length > 0) return;
    const id = activeDom.parents('.meta-table').length > 0 ? activeDom.parents('.meta-table')[0].id : this.tableGuid;
    if (id != uuid) return;
    var clipboardData = e.nativeEvent.clipboardData;
    if (!(clipboardData && clipboardData.items)) { // 是否有粘贴内容
      return;
    }
    var copy_content = null;
    for (var i = 0, len = clipboardData.items.length; i < len; i++) {
      var item = clipboardData.items[i];
      if (item.kind === 'string' && item.type == 'text/plain') {
        copy_content = clipboardData.getData('text/plain');
      }
    }
    if (copy_content) {
      if (cb.utils.isMac())
        this.pasteCell(copy_content.split('\r'));
      else
        this.pasteCell(copy_content.split('\r\n'));
    }
  }

  pasteCell = (copy_content) => {
    if (this.state.readOnly) return;// 只读状态
    const focusedRowIndex = this.props.model.getFocusedRowIndex();
    if (cb.utils.isEmpty(focusedRowIndex) || focusedRowIndex == -1) return;// 未选中行
    const Status = this.CellStatus;// 单元格编辑状态
    const data = { rowIndex: focusedRowIndex, cellName: '' };
    Status.map(function (item, index) {
      for (var items in item) {
        if (items != 'GridRowNo' && items != 'CheckBox') {
          if (item[items]) {
            data.cellName = items;
            data.rowIndex = index;
          }
        }
      }
    });
    if(cb.utils.isEmpty(data.cellName)) return;
    this.CellStatus[data.rowIndex][data.cellName] = false;
    const column = this.columns[data.cellName];
    const cControlType = column.cControlType && column.cControlType.trim().toLocaleLowerCase();
    if (!cb.utils.isMac() && copy_content.length > 1) copy_content = copy_content.splice(0, copy_content.length - 1);
    this.props.model.execute('beforePasteCell', { rowIndex: data.rowIndex, cellName: data.cellName });
    if (cControlType == 'refer' || cControlType == 'treerefer' || cControlType == 'listrefer') {
      this.pasteReferCell(copy_content, column);
      return
    }
    if (cControlType == 'inputnumber') {
      let a = true;
      for (var i = 0; i < copy_content.length; i++) {
        if (isNaN(Number(copy_content[i]))) {
          a = false;
          break;
        }
      }
      if (!a) {
        cb.utils.alert('数值列只允许粘贴数字，请修改后重试！', 'error');
        return
      }
    }
    if (cControlType == 'datepicker' || cControlType == 'datetimepicker') {
      let fmt = 'YYYY-MM-dd';
      if (cControlType == 'datetimepicker') fmt = 'YYYY-MM-DD HH:mm:ss';
      if (!cb.utils.isEmpty(column.cFormatData)) fmt = column.cFormatData;
      if (cb.utils.isIE()) fmt = fmt.replace(/-/g, '/');
      copy_content.map((val, index) => {
        if (!cb.utils.isEmpty(val)) copy_content[index] = format.dateFormat(new Date(val), fmt);
      });
    }
    if (copy_content.length == 1) {
      this.props.model.setCellValue(focusedRowIndex, data.cellName, copy_content[0], true);
    } else {
      var len = this.dataList.length - 1;
      copy_content.forEach((value, index) => {
        if (index > len) {
          if (!this.props.model.appendRow({})) return;
          this.props.model.setCellValue(focusedRowIndex + index, data.cellName, value, true);
        } else {
          this.props.model.setCellValue(focusedRowIndex + index, data.cellName, value, true);
        }
      });
    }
    this.props.model.execute('afterPasteCell', { rowIndex: data.rowIndex, cellName: data.cellName });
  }

  pasteReferCell = (copy_content, column) => {
    const referModel = this.props.model.getEditRowModel().get(column.cItemName);
    const referVm = referModel.getCache('vm');
    referVm.setCache('bPaste', true);
    referVm.setCache('pasteModel', this.props.model);
    const cCheckFlds = referVm.getCache('newCheckFlds');
    const simpleVOs = [{ logicOp: 'or', conditions: [] }];
    referVm.setCache('pasteList', copy_content);
    cCheckFlds.forEach(field => {
      simpleVOs[0].conditions.push({
        field: field, op: 'in', value1: copy_content
      })
    });
    cb.utils.triggerReferBrowse(referModel, simpleVOs);
  }

  //切换编辑单元格状态
  switchCell = () => {
    if (this.state.readOnly) return;//只读状态
    let focusedRowIndex = this.props.model.getFocusedRowIndex();
    if (cb.utils.isEmpty(focusedRowIndex) || focusedRowIndex == -1) return;//未选中行
    let Status = this.CellStatus;//单元格编辑状态
    let data = { rowIndex: focusedRowIndex, cellName: '' };
    Status.map(function (item, index) {
      for (var items in item) {
        if (items != 'GridRowNo' && items != 'CheckBox') {
          if (item[items]) {
            data.cellName = items;
            data.rowIndex = index;
          }
        }
      }
    });
    if (data.cellName == '') data.cellName = this.lastEditCell;
    setTimeout(() => {
      this.setCellEnter(data);
    }, 0);
  }
  //-----------------------------------------------------------设置grid中columns，datasource等属性--------------------------------------------------------------------------------------------------
  setListenerState = (params) => {
    if (params.columnMode === 'local' && this.props.columns) {
      const columns = {}, fieldNames = [];
      for (var attr in this.props.columns) {
        fieldNames.push(attr);
        var modelColumn = params.columns[attr];
        const viewColumn = this.props.columns[attr];
        if (!modelColumn) {
          modelColumn = {};
        } else {
          modelColumn.index = viewColumn.index;
          modelColumn.enterDirection = viewColumn.enterDirection;
          modelColumn.relatedActions = viewColumn.relatedActions;
        }
        const column = {};
        Object.assign(column, viewColumn, modelColumn);
        columns[attr] = column;
      }
      params.columns = columns;
      this.props.model._set_data('fieldNames', fieldNames);
    }
    if (this.props.widthMode == 'percent') {
      let tableWidth = this.props.width || 1100;
      for (var key in params.columns) {
        let iColWidth = parseFloat(params.columns[key].iColWidth);
        let width = isNaN(iColWidth) ? 25 : iColWidth;
        width = tableWidth * width / 100;
        params.columns[key].iColWidth = width;
      }
    }

    let tmp_ColIndexs = {};
    let index = 0;

    /*cellState*/
    if (params.cellState) {
      this.cellState = params.cellState;
    }


    //栏目col与index对照
    var hasColumn = false;
    for (var attr in params.columns) {
      hasColumn = true;
      if (index === 0) {
        tmp_ColIndexs[attr] = 0;
      } else {
        tmp_ColIndexs[attr] = index;
      }
      index = index + 1;
    }
    if (params.pageInfo) {
      this.setPageInfo(params.pageInfo);
    }
    this.colsWidth = this.computeColsWidth(params.columns);
    this.GridProps.showCheckBox = params.showCheckBox;//是否显示选择列
    this.GridProps.showRowNo = params.showRowNo;//是否显示行号
    if (this.props.tableClass == "rptTable")
      this.GridProps.showRowNo = true;
    this.GridProps.showAggregates = params.showAggregates;//是否显示合计
    this.GridProps.showSubtotal = params.showSubtotal;//是否显示小计
    if (this.props.T2D_TableNum == "2D") {
      this.GridProps.showAggregates = this.props.showAggregates;
      this.GridProps.showSubtotal = this.props.showSubtotal;
    }
    this.GridProps.isRadio = !params.multiple;//是否单选
    this.GridProps.isPagination = params.pagination;//是否分页
    this.GridProps.showColumnSetting = params.showColumnSetting;//是否显示栏目设置
    this.GridProps.multiSort = params.multiSort;//是否显示表头排序
    this.ColIndexs = tmp_ColIndexs;//栏目与index对照

    if (hasColumn) {
      this.columns = params.columns;
      if (params.rows && params.rows.length > 0) {
        this.dataList = params.rows;
        this.calcSubTotalData(params.columns, this.dataList);
      } else {
        this.dataList = [];
        this.calcSubTotalData(params.columns, this.dataList);
      }
      //初始化单元格状态
      this._InitCellStatus(params.columns, params.rows, params.mergeCells);
      this.readOnly = params.readOnly;
      let columnset = this.RemodelingColumn(params.rows, params.columns);
      this.setState({
        readOnly: params.readOnly,
        columnset,
        showColumnSetting: params.showColumnSetting,
        mergeCells: params.mergeCells,
        mergePosition: params.mergePosition,
        bLoadPagination: params.bLoadPagination,
        loadPageEnd: params.loadPageEnd
      });
    }
  }

  //初始化单元格状态
  _InitCellStatus = (Columns, DataSource, mergeCells) => {
    let self = this;
    /*初始化action列的渲染数据*/
    let action = this.props.action;
    if (action && action.cControlType && action.cControlType == 'Toolbar') {
      self.action = action;
      self.hasAction = true;
      let cStyle = action.cStyle;
      try {
        if (!cStyle || cStyle == '') {
          cStyle = {};
        } else {
          cStyle = JSON.parse(cStyle);
        }
      } catch (e) {
        cb.utils.alert('Toolbar cStyle，预制错误！', 'error');
      }
      this.fixedwidth = cStyle.fixedwidth;
    }
    // let containers = this.state.containers ? this.state.containers : [];
    let PopMeta = {};
    // containers.map(function (key) {
    //   if (key.cControlType == 'Toolbar') {/*操作列元数据*/
    //     self.action = key;
    //     self.hasAction = true;
    //   }
    //   if (key.cControlType == 'Pop') {/*组合控件元数据*/
    //     PopMeta[key.cGroupCode] = key;
    //   }
    // });
    if (DataSource !== undefined) {
      //设置初始单元格编辑状态/行选择初始状态/action状态/单元格状态 disabled/readOnly/style
      let temp_cellState = cb.utils.extend(true, [], this.cellState);
      let temp_isColErro = cb.utils.extend(true, [], this.isColErro);
      let temp_CellStatus = cb.utils.extend(true, [], this.CellStatus);
      let temp_rowStatus = cb.utils.extend(true, [], this.rowStatus);
      let temp_actionState = cb.utils.extend(true, {}, this.actionState);
      let temp_CompositeLayout = cb.utils.extend(true, [], this.CompositeLayout);//组合控件布局
      let temp_compositeControl = cb.utils.extend(true, [], this.compositeControl);//组合控件元数据
      let length = DataSource.length;
      if (length <= 0) return;
      for (let i = 0; i < length; i++) {
        if (!temp_CellStatus[i])
          temp_CellStatus[i] = {};
        if (DataSource[i]._selected !== true) DataSource[i]._selected = false;
        if (!temp_rowStatus[i])
          temp_rowStatus[i] = { disabled: false, visible: false };
        if (this.action && this.action.controls) {
          let actionList = this.action.controls;
          let _id = DataSource[i]._id;
          if (!temp_actionState[_id])
            temp_actionState[_id] = {};
          actionList.map(function (action) {
            if (!temp_actionState[_id][action.cItemName])
              temp_actionState[_id][action.cItemName] = { disabled: false, visible: true };
          });
        }
        if (!temp_cellState[i])
          temp_cellState[i] = {};
        if (!temp_isColErro[i])
          temp_isColErro[i] = {};
        if (!temp_CompositeLayout[i])
          temp_CompositeLayout[i] = {};
        if (!temp_compositeControl[i])
          temp_compositeControl[i] = {};
        for (var attr in Columns) {
          if (attr === 'CheckBox' || attr === 'GridRowNo') {
            temp_CellStatus[i][attr] = true;
          } else {
            if (!temp_CellStatus[i][attr])
              temp_CellStatus[i][attr] = false;
            if (!temp_cellState[i][attr])
              temp_cellState[i][attr] = { disabled: false, visible: false, readOnly: false, style: {}, className: "" };
            if (!temp_isColErro[i][attr])
              temp_isColErro[i][attr] = false;
            if (Columns[attr].cControlType == 'composite') {
              temp_CompositeLayout[i][attr] = Columns[attr].cRefRetId;
              temp_compositeControl[i][attr] = PopMeta[attr];
            }
          }
        }
      }
      if (temp_actionState) this.actionState = temp_actionState;
      this.CellStatus = temp_CellStatus;
      this.rowStatus = temp_rowStatus;
      this.cellState = temp_cellState;
      this.isColErro = temp_isColErro;
      this.CompositeLayout = temp_CompositeLayout;
      this.compositeControl = temp_compositeControl;
      /*合并列 对照*/
      if (mergeCells || this.state.mergeCells)
        this.initMergeColContrast(DataSource, Columns);
    }
  }
  /*小计*/
  calcSubTotalData = (columns, data) => {
    if (!data || data.length == 0) return;
    let subtotalData = {};
    for (var key in columns) {
      if (columns[key].bNeedSum) {
        let sum = 0;
        data && data.map(row => {
          let val = row[key] ? row[key] : 0;
          sum = getMultiplication(sum, parseFloat(val), 'add');
        });
        subtotalData[key] = sum;
      }
    }
    this.setState({ subtotalData });
    if (this.props.model)
      this.props.model.execute('afterCalcSubTotal', subtotalData);
  }
  //----------------------------------------------接受viewmodeld参数-----------------------------------------------------------------------------------------------
  //接受来自model的column信息
  setColumns = (columndata) => {
    let tmp_ColIndexs = {}, index = 0, hasSpecialCol = false, specialCols = [];
    if (this.props.widthMode == 'percent') {
      let tableWidth = this.props.width || 1100;
      for (var key in columndata) {
        let iColWidth = parseFloat(columndata[key].iColWidth);
        let width = isNaN(iColWidth) ? 25 : iColWidth;
        width = tableWidth * width / 100;
        columndata[key].iColWidth = width;
      }
    }
    for (var key in columndata) {
      if (columndata[key].cControlType == 'specialcom' && hasSpecialCol == false) {
        hasSpecialCol = true;
        specialCols.push(key);
      }
      if (index === 0) {
        tmp_ColIndexs[key] = 0;
      } else {
        tmp_ColIndexs[key] = index;
      }
      index = index + 1;
    }
    this.hasSpecialCol = hasSpecialCol;
    this.specialCols = specialCols;
    this.colsWidth = this.computeColsWidth(columndata);
    this.ColIndexs = tmp_ColIndexs;
    this.groupHeaderHeight = 0;
    this.lastCol = null;
    this._InitCellStatus(columndata, this.dataList);
    let columnset = this.RemodelingColumn(this.dataList, columndata);
    this.columns = columndata;
    // if (this.props.tableTyep == 'rptTable') {
    //   let showAggregates = false;
    //   for (var key in columndata) {
    //     if (columndata[key].bNeedSum) {
    //       showAggregates = true;
    //       break;
    //     }
    //   }
    //   this.GridProps.showAggregates = showAggregates;
    // if (this.props.T2D_TableNum == "2D")
    // this.GridProps.showAggregates = this.props.showAggregates; ;
    // }
    this.setState({ columnset });

  }
  computeColsWidth = (columns) => {
    let colsWidth = 0;
    for (var key in columns) {
      let iColWidth = cb.utils.isEmpty(columns[key].iColWidth) ? 150 : parseFloat(columns[key].iColWidth);
      colsWidth += iColWidth;
    }
    return colsWidth;
  }
  initMergeColContrast = (dataSource, columns) => {
    let mergeColContrast = {};
    for (var key in columns) {
      mergeColContrast[key] = [];
      dataSource.map(row => {
        mergeColContrast[key].push(0);
      });
    }
    this.mergeColContrast = mergeColContrast;
  }
  setMergeColContrast = (mergeColContrast) => {
    this.mergeColContrast = mergeColContrast;
  }
  setSum = (sumData) => {
    // if (sumData.length > 0)
    this.setState({
      sumData
    })
  }
  //接收来自model的data信息
  setDataSource = (data) => {
    this.selectIndex = -1;
    this.dataList = data;
    this.allSelect = false;
    this.indeterminate = false;
    //初始化单元格状态
    this._InitCellStatus(this.columns, data);
    let columnset = this.RemodelingColumn(data, this.columns);
    this.setState({ columnset });

    let selectRows = this.props.model.getSelectedRowIndexes();
    if (selectRows[0]) {
      this.scrollRow = selectRows[0];
    } else {
      this.scrollRow = 0;
      this.scrollEndHeight = 0;
      this.nowSetDataSource = true;
    }
    /*重算小计*/
    this.calcSubTotalData(this.columns, this.dataList);
  }

  // 设置快捷键聚焦行
  setKeyboardIndex = (value, name) => {
    this.scrollRow = value
  }

  //---------------------------------------------组织grid结构----------------------------------------------------------------------------------------------------------------
  //组织column结构
  RemodelingColumn = (dataList, columnState) => {
    let self = this, ret = [], columnData = [], actionAlign = '', Operation = {};

    let isGroup = false;/*是否多表头*/
    self.isGroup = false;
    for (var attr in columnState) {
      if (columnState[attr].parent) {
        isGroup = true;
        self.isGroup = true;
        break;
      }
    }
    if (isGroup && this.props.T2D_TableNum != "2D") {
      if (this.state.groupShowCheckBox && this.GridProps.showCheckBox && !columnState.showCheckBox)
        columnState.CheckBox = { 'cItemName': 'CheckBox', 'iColWidth': 45, 'cControlType': 'SelectCheckBox' };
      /*行号*/
      if (this.GridProps.showRowNo && !columnState.GridRowNo) 
          columnState.GridRowNo = { 'cItemName': 'GridRowNo', 'iColWidth': 40, 'cControlType': 'Input' };
      return this.RemodelingGroupColumn(dataList, columnState);
    }

    const readOnly = this.readOnly;
    /*操作列*/
    if (this.action.controls) {
      // if (readOnly === false && this.action.controls) {
      columnState.Operation = { 'cItemName': 'Operation', 'iColWidth': readOnly === false ? 70 : 0, 'cControlType': 'Action' };
      if (this.fixedwidth && readOnly === false) columnState.Operation.iColWidth = this.fixedwidth;
      columnData.push(columnState.Operation);
    }
    /*选择列*/
    // if (this.GridProps.showCheckBox && this.props.tableTyep != 'rptTable') {
    if (this.props.T2D_TableNum != "2D" && this.GridProps.showCheckBox) {
      if (!columnState.CheckBox)
        columnState.CheckBox = { 'cItemName': 'CheckBox', 'iColWidth': 45, 'cControlType': 'SelectCheckBox' };
      columnData.push(columnState.CheckBox);
    }
    /*行号*/
    if (this.GridProps.showRowNo) {
      if (!columnState.GridRowNo)
        columnState.GridRowNo = { 'cItemName': 'GridRowNo', 'iColWidth': 40, 'cControlType': 'Input' };
      columnData.push(columnState.GridRowNo);
    }
    // /*固定左位置的操作列*/
    // if (actionAlign == 'left') {
    //   columnState.Operation = Operation;
    //   columnData.push(columnState.Operation);
    // }
    let tmp;
    for (var attr in columnState) {
      if (attr != 'CheckBox' && attr != 'GridRowNo' && attr != 'Operation' && attr != 'ColumnSetting') {
        tmp = columnState[attr];
        columnData.push(columnState[attr]);
      }
    }
    /* 栏目设置  自占一列   解决最后一列居右 标题被挡住问题  存在action列不需要占位 */
    const tableWidth = this.props.width || 1100;
    if (this.props.T2D_TableNum != '2D' && this.state.showColumnSetting && this.readOnly && this.colsWidth > tableWidth) {
      if (!columnState.ColumnSetting)
        columnState.ColumnSetting = { cShowCaption: '', cItemName: 'ColumnSetting', iColWidth: 50, cControlType: 'Input', bIsNull: true };
      columnData.push(columnState.ColumnSetting);
    }
    if (tmp) {
      if (!this.lastCol || this.lastCol.cFieldName != tmp.cFieldName) {
        this.lastCol = _.cloneDeep(tmp);
      }
      // if (this.state.showColumnSetting) {
      //   tmp.iColWidth = this.lastCol.iColWidth + 50;
      // }
      // else {
      //   tmp.iColWidth = this.lastCol.iColWidth;
      // }
    }
    if (isGroup && this.props.T2D_TableNum == "2D") {
      return this.RemodelingGroupColumn(dataList, columnState);
    }
    // /*右位置的操作列*/
    // if (actionAlign == 'right') {
    //   Operation.bFixed = 0;
    //   columnState.Operation = Operation;
    //   columnData.push(columnState.Operation);
    // }
    // if (this.props.widthMode == 'percent') {
    //   let tableWidth = this.props.width || 1100;

    //   this.totalWidth = 0;
    //   columnData.map(function (col) {
    //     let column = self.setColumn(col.cItemName, col);
    //     let iColWidth = parseFloat(col.iColWidth);
    //     let width = isNaN(iColWidth) ? 25 : iColWidth;
    //     width = tableWidth * width / 100;
    //     col.iColWidth = width;
    //     this.totalWidth += width;
    //     ret.push(column);
    //   }, this);
    //   return ret;
    // } else {
    this.totalWidth = 0;
    let _index = _.findIndex(columnData, (obj) => {
      return obj.cItemName == this.lockstate
    })
    columnData.map(function (col, index) {
      if (_index > -1) {
        let colfixed = { bFixed: 1 };
        let _colfixed = { bFixed: 0 }
        if (_index != index) {
          _index > index ? Object.assign(col, colfixed) : Object.assign(col, _colfixed)
        }
        else {
          this.unlockstate ? Object.assign(col, colfixed) : Object.assign(col, _colfixed)
        }
      }
      let column = self.setColumn(col.cItemName, col);
      let iColWidth = parseFloat(col.iColWidth);
      let width = isNaN(iColWidth) ? 150 : iColWidth;
      this.totalWidth += width;
      ret.push(column);
    }, this);
    if (this.GridProps.showAggregates && tableWidth > this.totalWidth) {
      const column = self.setColumn('emptyCol', { cItemName: 'emptyCol', iColWidth: tableWidth - this.totalWidth, cControlType: 'Input', bIsNull: true });
      ret.push(column);
    }
    return ret;
    // }
  }

  /*多表头*/
  RemodelingGroupColumn = (dataList, columnState) => {

    /*行号*/
    // columnState.GridRowNo = { 'cFieldName': 'GridRowNo', 'cItemName': 'GridRowNo', 'iColWidth': 30, 'cControlType': 'Input' };

    let cols = {};
    let columns = cb.utils.extend(true, {}, columnState);
    this.totalWidth = 0;
    var lockIndex = cb.utils.isEmpty(this.ColIndexs[this.lockstate]) ? -1 : this.ColIndexs[this.lockstate];
    if (!this.unlockstate) lockIndex = -1;
    for (var key in columns) {
      let item = columns[key];//栏目属性对象
      let nowIndex = this.ColIndexs[key];
      if (nowIndex <= lockIndex) item.bFixed = 1;
      item.iColWidth = !cb.utils.isEmpty(columns[key].iColWidth) ? parseFloat(item.iColWidth) : 150;
      if (!item.parent) {
        cols[item.cItemName] = item;
      } else {
        this.loopColumn(item.parent, cols, item);
      }
      this.totalWidth += item.iColWidth;
    }
    return this.restructureColumn(dataList, cols);
  }
  /*组织多表头栏目*/
  restructureColumn = (dataList, columns) => {
    let col = [];
    for (var key in columns) {
      let item = columns[key];//栏目属性对象
      if (item.children) {
        let children = this.loopChildren(item);
        let header = this.getGroupHeader(item);
        col.push(
          <ColumnGroup key={item.cFieldName} header={header}>
            {children}
          </ColumnGroup>
        );
      } else {
        let column = this.setColumn(item.cItemName, item);
        let fixed = false;
        if (item.cItemName == 'CheckBox' || item.cItemName == 'GridRowNo') fixed = true;
        col.push(
          <ColumnGroup fixed={fixed} key={item.cFieldName} header={<Cell><div className='headerName' style={{ "height": this.headerHeight }}></div></Cell>}>
            {column}
          </ColumnGroup>
        )
      }
    }
    return col;
  }
  /*组织多表头显示组件*/
  getGroupHeader = (item) => {
    let header = [];
    header.push(
      <Row className="group-row" style={{ "height": (this.headerHeight || 40) }}>
        <div className="group-col" style={{ "height": (this.headerHeight || 40) }}>{item.cShowCaption}</div>
      </Row>
    )
    let headerRow = this.getHeaderRow(item.children);
    if (headerRow.length > 0) {
      let i = 1;
      headerRow.map(row => {
        header.push(
          <Row className="group-row" style={{ "height": (this.headerHeight || 40) }}>{row}</Row>
        )
        i += 1;
      });
      this.groupHeaderHeight = i * (this.headerHeight || 40);
    } else {
      this.groupHeaderHeight = (this.headerHeight || 40);
    }
    let rowWidth = this.getGroupHeaderWidth(item.children);
    return <div className="table-group-header" style={{ "width": rowWidth }}>{header}</div>
  }
  /*组织多表头的行表头*/
  getHeaderRow = (children) => {
    let headerRows = [], headerRow = [];
    children.map(col => {
      if (col.children) {
        var width = this.getGroupHeaderWidth(col.children);
        col.iColWidth = width;
        headerRow.push(
          <div className="group-col" style={{ "height": (this.headerHeight || 40), "width": width }}>{col.cShowCaption}</div>
        )
        if (col.children[0].children) {
          let newRow = this.getHeaderRow(col.children);
          headerRows[headerRows.length] = newRow;
        }
      }
    });
    if (headerRow.length > 0)
      headerRows[headerRows.length] = headerRow;
    return headerRows;
  }
  /*获取多表头宽度*/
  getGroupHeaderWidth = (item) => {
    var width = 0;
    item.map(col => {
      let w = this.loopHeader(col, width);
      width += w;
    });
    return width;
  }
  loopHeader = (item) => {
    let children = item.children;
    let width = 0;
    if (children) {
      children.map(col => {
        if (col.iColWidth) {
          width += col.iColWidth;
        } else {
          width += this.loopHeader(col);
        }
      });
    } else {
      width = !cb.utils.isEmpty(item.iColWidth) ? item.iColWidth : 150;
    }
    return width;
  }
  loopChildren = (item) => {
    let col = [];
    item.children.forEach(function (ele) {
      if (ele.children) {
        let children = this.loopChildren(ele);
        col = col.concat(children);
      } else {
        let column = this.setColumn(ele.cItemName, ele);
        col.push(column)
      }
    }, this);

    return col;
  }
  loopColumn = (data, cols, item, child) => {
    if (!data.parent) {
      if (!cols[data.cFieldName]) {
        cols[data.cFieldName] = data;
        cols[data.cFieldName].children = [];
      }
      if (child && child.parent) delete child.parent;
      let colsChild = cols[data.cFieldName].children;
      let existChild = false, existIndex = 0;
      colsChild.forEach(function (ele, index) {
        if (ele.cFieldName == item.cFieldName) {
          existIndex = index;
          existChild = true;
        }
      }, this);

      if (existChild) {
        cols[data.cFieldName].children[existIndex].children.push(child);
      } else {
        if (child) {
          item.children = [child];
        }
        if (item.parent) delete item.parent;
        cols[data.cFieldName].children.push(item);
      }
    } else {
      this.loopColumn(data.parent, cols, data, item);
    }
  }


  //设置column
  setColumn = (attr, col) => {
    let controlType = col.cControlType && col.cControlType.trim().toLocaleLowerCase();
    var iColWidth = parseFloat(col.iColWidth);
    let width = isNaN(iColWidth) ? 150 : iColWidth;
    var name = col.cShowCaption;
    let headerCell, headerClassName = '';
    let fiexd = col.bFixed == 1 ? true : false;
    let align = 'left';
    if (col.iAlign === 2) align = 'center';
    if (col.iAlign === 3) align = 'right';
    if (attr === 'CheckBox') {
      if (!this.GridProps.isRadio) {
        let model = this.props.model.getEditRowModel().get(attr);
        headerCell = (
          <Cell>
            <div className='checkboxHD'>
              <Checkbox indeterminate={this.indeterminate} checked={this.allSelect} onChange={(e, i) => this.SelectChange(e, -1)}></Checkbox>
            </div>
          </Cell>
        );
      }
      fiexd = true, align = 'center';
    } else if (attr === 'GridRowNo') {
      fiexd = true, align = 'center';
      headerCell = (<Cell><div className='headerName line-number' style={{ "height": this.headerHeight }}></div></Cell>);
    } else if (attr === 'Operation') {
      headerCell = (<Cell><div className='headerName' style={{ "height": this.headerHeight }}></div></Cell>);
      return (<Column key={attr}
        allowCellsRecycling columnKey={attr} isResizable={true}
        header={headerCell} cell={(rowIndex) => this.setCell(rowIndex, col)}
        width={width} align="center" fixedRight={true} footer={this._setFooter} />);
    } else if (controlType == 'vouchermoney') {/*凭证 金额*/
      width = 175, align = 'left', this.headerHeight = 60;
      headerCell = (
        <Cell>
          <Row className={"CredentialsHeader"}>
            <ul className={"CredentialsTitle"}>{name}</ul>
            <ul className={"CredentialsMoney"}>
              <li className={"firstCol"}>亿</li>
              <li>千</li>
              <li>百</li>
              <li className={"lineBlue"}>十</li>
              <li>万</li>
              <li>千</li>
              <li className={"lineBlue"}>百</li>
              <li>十</li>
              <li>元</li>
              <li className={"lineRed"}>角</li>
              <li>分</li>
            </ul>
          </Row>
        </Cell>
      );
    } else {
      if (!col.bCanModify && !this.readOnly) {
        headerClassName = 'public_fixedDataTableCell_disabled';
      } else {
        headerClassName = 'headerName';
      }
      let fixedtable = this.refs.fixedtable;
      headerCell = (
        <Cell className={headerClassName}>
          <GridFilterModel align={align} fixedtable={fixedtable} multiSort={this.GridProps.multiSort} tableClass={this.props.tableClass} readOnly={this.readOnly} Column={col} name={name} model={this.props.model} width={width} attr={attr} data={this.dataList}
            onSortChange={this.onSortChange} sortColumn={this.sortColumn} lookUpRow={this.lookUpRow} onlockChange={this.onlockChange} lockstate={this.lockstate} lockfixed={fiexd}
            moveLookUpRow={this.moveLookUpRow} lookUpKey={this.lookUpKey}
          />
        </Cell>
      )
    }
    if (this.lastCol && attr == this.lastCol.cItemName) {
      let tableWidth = this.props.width || 1100;
      // if (this.GridProps.showAggregates) {
      //   if (tableWidth > this.colsWidth && (tableWidth - this.colsWidth) > width)
      //     width = tableWidth - this.colsWidth;
      // }
      // if (this.props.T2D_TableNum != "2D" && this.state.showColumnSetting && tableWidth < this.totalWidth)
      //   width += 50;
      if (this.state.showColumnSetting && tableWidth < this.totalWidth)
        width += 50;
    }
    return (<Column key={attr}
      // isReorderable={true}
      allowCellsRecycling columnKey={attr} isResizable={true}
      header={headerCell} cell={(rowIndex) => this.setCell(rowIndex, col)}
      width={width} align={align} fixed={fiexd} footer={this._setFooter} />);
    // footer={this._setFooter}
  }
  moveLookUpRow = (lookUpRowIndexes, lookUpRow, key) => {
    if (lookUpRow > -1) this.scrollRow = lookUpRow;
    this.lookUpRowIndexes = lookUpRowIndexes;
    this.lookUpRow = lookUpRow;
    this.lookUpKey = key;
    this._triggerRender();
  }
  onSortChange = (key) => {
    this.sortColumn = key;
  }
  onlockChange = (key, state) => {
    this.lockstate = key;
    this.unlockstate = state
    this._triggerRender();
  }
  setCell = (rowIndex, col) => {
    let isColErro = this.isColErro[rowIndex.rowIndex][rowIndex.columnKey] ? this.isColErro[rowIndex.rowIndex][rowIndex.columnKey] : false;
    if (this.state.style && this.state.style.height) {
      this.rowheight = this.state.style.height;
    }
    return (<CellModel
      dataList={this.dataList} readOnly={this.readOnly} selectIndex={this.selectIndex} rowStatus={this.rowStatus} CellStatus={this.CellStatus} RowProperty={rowIndex} selectAllState={this._selectAllState} ColIndexs={this.ColIndexs} mergeColContrast={this.mergeColContrast}
      action={this.action} actionState={this.actionState} selectAll={this.allSelect} indeterminate={this.indeterminate} cellState={this.cellState} isColErro={isColErro} Column={col} model={this.props.model} GridProps={this.GridProps} onCellClick={this._onCellClick} triggerRender={this._triggerRender} columnsList={this.columns} CompositeLayout={this.CompositeLayout} rowHeight={this.props.rowHeight || 50} compositeControl={this.compositeControl} setCellBlur={this.setCellBlur}
      setMergeColContrast={this.setMergeColContrast} mergeCells={this.state.mergeCells} mergePosition={this.state.mergePosition} showAction={this.state.showAction[rowIndex.rowIndex]}
      rowHeight={this.rowheight} showActionIndex={this.showActionIndex} ActionClick={this.ActionClick}
    />);
  }
  _triggerRender = () => {
    var columnset = this.RemodelingColumn(this.dataList, this.columns);
    this.setState({ columnset });
  }

  //------------
  _selectAllState = (selectAll, indeterminate) => {
    this.allSelect = selectAll;
    this.indeterminate = indeterminate;
    this._triggerRender();
  }
  //监听全选
  SelectChange = (e, index) => {
    if (!e.target.checked) {
      this.props.model.unselectAll();
    } else {
      this.props.model.selectAll();
    }
  }

  //列宽改变拖动函数
  _onColumnResizeEndCallback = (newColumnWidth, columnKey) => {
    // if (newColumnWidth < 40) return
    if (!this.columns[columnKey]) return
    this.columns[columnKey].iColWidth = newColumnWidth;
    let columnset = this.RemodelingColumn(this.dataList, this.columns);
    this.setState({ columnset });
  }
  // _onColumnReorderEndCallback = (event) => {
  //   const { columnAfter, columnBefore, reorderColumn } = event;
  //   let columns = this.columns;
  //   let newColIndex = cb.utils.extend(true, {}, this.ColIndexs);
  //   let initialIndex = this.ColIndexs[columnAfter];
  //   for (var j = initialIndex; j <= this.ColIndexs[reorderColumn]; j++) {
  //     for (var key in this.ColIndexs) {
  //       if (this.ColIndexs[key] == j) {
  //         initialIndex++;
  //         newColIndex[key] = initialIndex;
  //       }
  //     }
  //   }
  //   // newColIndex[columnAfter] = this.ColIndexs[reorderColumn];
  //   newColIndex[reorderColumn] = this.ColIndexs[columnAfter];
  //   let columnsCount = 0;
  //   for (var key in columns) {
  //     columnsCount++;
  //   }
  //   let newColumns = {};
  //   for (var i = 0; i < columnsCount; i++) {
  //     for (var key in newColIndex) {
  //       if (newColIndex[key] == i) {
  //         newColumns[key] = columns[key];
  //         break;
  //       }
  //     }
  //   }
  //   this.ColIndexs = newColIndex;
  //   this.setColumns(newColumns);
  // }
  //行单击事件
  _onRowClick = (e, index) => {
    this.scrollRow = index;
    if (e && e.target && cb.dom(findDOMNode(e.target)).parents('.first-checkbox').length) return;
    if (this.dataList.length == 0 || !this.dataList[index]) return;
    /*可编辑   多选  rowClick不走select   单选走select*/
    if (!this.state.readOnly) {
      this.selectIndex = index;
      if (this.GridProps.showCheckBox)
        this.props.model.setFocusedRowIndex(index);
      else
        this.props.model.select(index);
      return
    }
    let all = false;
    if (this.GridProps.isRadio || this.props.hasAction) all = true;
    if (all) {
      this.props.model.select(index, all);
    } else {
      let indexes = this.props.model.getSelectedRowIndexes();
      let i = indexes.findIndex(function (val) {
        return val == index;
      });
      if (this.GridProps.showCheckBox)
        all = false;
      else
        all = true;
      if (i == -1)
        this.props.model.select(index, all)
      else
        this.props.model.unselect(index)
    }
  }

  //单元格单击事件
  _onCellClick = (e, index, columnKey, source, errorCannotContinue) => {

    this._isRowColChange({ rowIndex: index, columnKey: columnKey, column: this.columns[columnKey] }, () => {
      let ColIndex = this.ColIndexs[columnKey];
      let data = { index: index, columnKey: columnKey };
      if (!this.props.model.execute('onEdit', data)) return;
      let column = this.columns[columnKey];
      if (column.cControlType == 'switchlabel') {
        this.props.model.setFocusedRowIndex(index);
      }
      if (this.CellStatus[index] !== undefined) {
        this.CellStatus[index][columnKey] = true;
        this.scrollCol = ColIndex + 2;
        this._triggerRender();
      }
    }, () => {
      if (source == 'enter') {
        if (errorCannotContinue) return;
        this.setCellEnter({ rowIndex: index, cellName: columnKey });
      }
    });
  }
  //判断是否row col change事件
  _isRowColChange = (value, callback, errCallBack) => {
    let oldValue = this.RowCol;
    if (oldValue.rowIndex != value.rowIndex || oldValue.columnKey != value.columnKey) {
      var callback1 = () => {
        oldValue.rowIndex = value.rowIndex;
        oldValue.columnKey = value.columnKey;
        callback();
      }
      this.props.model.promiseExecute('rowColChange', { value: value, oldValue: oldValue }, [callback1, errCallBack]);
    } else {
      callback();
    }
  }
  //单元格数据改变事件
  setCellValue = (data) => {
    this.dataList[data.rowIndex][data.cellName] = data.value;
    let columnset = this.RemodelingColumn(this.dataList, this.columns);
    /*重算小计*/
    this.calcSubTotalData(this.columns, this.dataList);
    this.setState({ columnset });
  }

  //双击事件
  _onRowDoubleClick = (e, index) => {
    let dataArry = this.dataList;
    let rowData = dataArry[index];
    this.props.model.fireEvent('dblClick', rowData);
  }

  setCellBlur = (data) => {
    this.CellStatus[data.rowIndex][data.cellName] = false;
    this.lastEditCell = data.cellName;
    if (this._triggerRender)
      this._triggerRender();
  }

  setCellEnter = (data) => {
    let keyIndex = this.ColIndexs[data.cellName];
    let cellState = this.cellState;
    let column = this.columns;
    let rowsCount = this.props.model.getRowsCount();
    let firstModifyKey = null;
    let enterDirection = column[data.cellName] ? column[data.cellName].enterDirection : null;
    if (enterDirection == null) return;
    let i = 1, columnKey, rowIndex;
    for (var key in column) {
      if (column[key].bCanModify) {
        firstModifyKey = key;
        break;
      }
    }
    /*1向上 2向下 3向左 4向右*/
    switch (enterDirection) {
      case 1:/*回车向上*/
        if (data.rowIndex == 0) return;
        columnKey = data.cellName;
        rowIndex = data.rowIndex - 1;
        this._onRowClick(null, rowIndex);
        break;
      case 2:/*回车向下*/
        columnKey = data.cellName;
        rowIndex = data.rowIndex + 1;
        if (rowIndex == rowsCount)
          this.props.model.appendRow({});
        this._onRowClick(null, rowIndex);
        this.scrollRow = rowIndex;
        break;
      case 3:/*回车向左*/
        if (keyIndex == 0) return;
        for (var attr in this.ColIndexs) {
          if (this.ColIndexs[attr] === keyIndex - i) {
            if (column[attr].bCanModify) {
              columnKey = attr;
            } else {
              i = i + 1;
            }
          }
        }
        rowIndex = data.rowIndex;
        break;
      case 4:/*回车向右*/
        for (var attr in this.ColIndexs) {
          if (this.ColIndexs[attr] === keyIndex + i) {
            if (column[attr].bCanModify) {
              if (cellState[data.rowIndex] && cellState[data.rowIndex][attr])
                if (cellState[data.rowIndex][attr].disabled || cellState[data.rowIndex][attr].readOnly)
                  i = i + 1;
                else
                  columnKey = attr;
              else
                columnKey = attr;
            } else {
              i = i + 1;
            }
          }
        }
        if (!columnKey) {
          rowIndex = data.rowIndex + 1;
          columnKey = firstModifyKey;
          if (rowIndex == rowsCount)
            this.props.model.appendRow({});
        } else {
          rowIndex = data.rowIndex;
        }
        break;

      default:/*回车向右*/
        rowIndex = data.rowIndex;
        break;
    }
    if (rowIndex != this.selectIndex) {
      this.props.model.setFocusedRowIndex(rowIndex);
      this.selectIndex = rowIndex;
    }
    if (!columnKey) return;
    this.CellStatus[data.rowIndex][data.cellName] = false;
    this._onCellClick(null, rowIndex, columnKey, 'enter', enterDirection === 2);
  }

  //-------------------------------------------------------------------viewmodel返调用方法------------------------------------------------------------------------------
  select = (indexes) => {
    for (var i = 0; i < this.dataList.length; i++) {
      this.dataList[i]._selected = false;
    }
    let indexLen = indexes ? indexes.length : 0;
    let dataLen = this.dataList.length;
    let index = indexLen == dataLen - 1 ? indexLen : indexLen + 1;
    indexes && indexes.forEach((index) => {
      this.dataList[index]._selected = true;
    });
    if (!cb.utils.isEmpty(indexes[index])) {
      this.selectIndex = indexes[index] * 1;
      // this.scrollRow = indexes[index];
    } else {
      if (this.GridProps.showCheckBox) {
        this.selectIndex = -1;
        // this.scrollRow = 0;
      } else {
        this.selectIndex = indexes[0];
        // this.scrollRow = indexes[0];
      }
    }
    this.updateindeterminate();
  }

  unselect = (indexes) => {
    for (var attr in indexes) {
      this.dataList[indexes[attr]]._selected = false;
    }
    this.updateindeterminate();
  }
  selectAll = () => {
    this.dataList.map((item, index) => {
      this.dataList[index]._selected = true;
    });
    this.allSelect = true;
    this.indeterminate = false;
    this._triggerRender();
  }
  unselectAll = () => {
    this.dataList.map((item, index) => {
      this.dataList[index]._selected = false;
    });
    this.allSelect = false;
    this.indeterminate = false;
    this._triggerRender();
  }
  setScrollRow = (index) => {
    this.scrollRow = index;
    this._triggerRender();
  }
  updateindeterminate = () => {
    let data = this.dataList;
    let j = 0, indexes = [], selectAll = false, indeterminate = false;
    data.forEach((item, index) => {
      if (!item._selected) return;
      indexes.push(index);
      j++;
    });
    if (j == 0) {
      selectAll = false;
      indeterminate = false;
    } else if (j > 0 && j < data.length) {
      selectAll = false;
      indeterminate = true;
    } else if (j == data.length) {
      selectAll = true;
      indeterminate = false;
    }
    this._selectAllState(selectAll, indeterminate);
  }
  //model调用  set行状态
  setRowState = (data) => {
    // if (data.propertyName == 'disabled')
    this.rowStatus[data.rowIndex][data.propertyName] = data.value;
    this._triggerRender();
  }
  setRowStates = (rowStates) => {
    rowStates.forEach(item => {
      this.rowStatus[item.rowIndex][item.propertyName] = item.value;
    });
    this._triggerRender();
  }
  //model调用  set action列状态
  setActionState = (data) => {
    let row = this.dataList[data.rowIndex];
    let actionState = this.actionState;
    if (actionState[row._id] && actionState[row._id][data.itemName])
      actionState[row._id][data.itemName][data.name] = data.value;
    this._triggerRender();
  }
  setActionsState = (data) => {
    this.dataList.map((row, index) => {
      this.actionState[row._id] = data[index];
    })
    this._triggerRender();
  }
  setReadOnly(value) {
    this.readOnly = value;
    var columnset = this.RemodelingColumn(this.dataList, this.columns);
    this.setState({ readOnly: value, columnset });
  }
  //model调用  set 组合控件的显示布局
  setCompositeLayout = (data) => {
    this.CompositeLayout[data.rowIndex][data.itemName] = data.value;
    this._triggerRender();
  }
  //model调用  set 组合控件的显示布局
  setCompositeMeta = (data) => {
    this.compositeControl[data.rowIndex][data.itemName] = data.value;
    this._triggerRender();
  }
  //model调用  set单元格状态
  setCellState = (data) => {
    let state = this.cellState;
    if (state[data.rowIndex][data.cellName]) {
      if (state[data.rowIndex][data.cellName][data.propertyName] == data.value) return;
      state[data.rowIndex][data.cellName][data.propertyName] = data.value;
      this._triggerRender();
    }
    //index cellName name value  oldvalue
  }
  setCellStates = (data) => {
    let state = this.cellState;
    data.map(row => {
      if (state[row.rowIndex][row.cellName]) {
        if (state[row.rowIndex][row.cellName][row.propertyName] == row.value) return;
        state[row.rowIndex][row.cellName][row.propertyName] = row.value;
      }
    });
    this._triggerRender();
    //index cellName name value  oldvalue
  }
  //--------------------------------------------------------------------------grid按钮事件------------------------------------------------------------------------------------------------
  //更新行
  updateRow = (data) => {
    if (data.index.length) {
      data.index.forEach((rowIndex, index) => {
        this.dataList[rowIndex] = data.row[index];
      });
    } else {
      this.dataList[data.index] = data.row;
    }
    /*重算小计*/
    this.calcSubTotalData(this.columns, this.dataList);
    this._triggerRender();
  }

  //增行
  insertRow = (data) => {
    this.dataList.splice(data.index, 0, data.row);
    //设置新增行单元格初始状态
    this._InitCellStatus(this.columns, this.dataList);
    // this.scrollRow = this.dataList.length - 1;
    this.scrollRow = data.index;/*插行滚动问题*/
    // this._triggerRender();
    this.props.model.select(data.index);
    /*重算小计*/
    this.calcSubTotalData(this.columns, this.dataList);
  }
  //批量增行/插行
  insertRows = (data) => {
    if (this.dataList.length == 0) {
      this.setDataSource(data.rows);
    } else {
      for (var i = 0; i < data.rows.length; i++) {
        this.dataList.splice(data.index + i, 0, data.rows[i])
      }
      this._InitCellStatus(this.columns, this.dataList);
      // this._triggerRender();
      this.props.model.select(data.index + data.rows.length - 1);
    }
    /*重算小计*/
    this.calcSubTotalData(this.columns, this.dataList);
  }
  batchInsertRow = (data) => {
    data.forEach(item => {
      const { rowIndex, rowData } = item;
      this.dataList.splice(rowIndex, 0, rowData);
    });
    this._InitCellStatus(this.columns, this.dataList);
    /*重算小计*/
    this.calcSubTotalData(this.columns, this.dataList);
    this._triggerRender();
  }
  //删行
  deleteRows = (indexes) => {
    indexes.map(index => {
      this.rowStatus.splice(index, 1);
    });
    /*重算小计*/
    this.calcSubTotalData(this.columns, this.dataList);
    this._triggerRender();
  }
  validate = (val) => {
    if (val.type == 'error') {
      if (val.data) {
        let isColErro = this.isColErro;
        const errorRows = {};
        const errorMsg = [];
        isColErro.map(function (item) {
          for (var key in item) {
            item[key] = false;
          }
        });
        val.data.map(function (item) {
          if (isColErro[item.rowIndex][item.cellName] != undefined && isColErro[item.rowIndex][item.cellName] != 'undefined')
            isColErro[item.rowIndex][item.cellName] = true;
          // Message.error('表体存在必输项，请输入完整在尝试保存！');
          // cb.utils.alert('表体存在必输项，请输入完整在尝试保存！', 'error');
          if(errorRows[item.rowIndex]){
            errorRows[item.rowIndex].push(item && item.cShowCaption);
          }else{
            errorRows[item.rowIndex] = [item && item.cShowCaption];
          }
        });
        this._triggerRender();
        errorMsg.push(<div>表体存在必输项，请输入完整再尝试保存！</div>)
        Object.keys(errorRows).forEach(el=>{
          errorMsg.push(<div>{`【第${parseInt(el)+1}行】${errorRows[el].join('、')}`}</div>);
        })
        
        cb.utils.alert({title: '', type: 'error', content:errorMsg , duration: 666});

      } else {
        cb.utils.alert('表体数据为空！不允许保存！', 'error');
      }
    } else {
      let colErr = {};
      for (var key in this.columns) {
        colErr[key] = false;
      }
      for (var i = 0; i < this.isColErro.length; i++) {
        this.isColErro[i] = colErr;
      }
    }
  }
  //---------------------------------------------------------------------------------分页相关-----------------------------------------------------------------------------------
  //设置分页
  setPageInfo = (paginationlist) => {
    if (paginationlist.pageSize === -1)
      this.GridProps.isPagination = false;
    var pageinfo = this.state.pagination;
    pageinfo.total = paginationlist.recordCount
    pageinfo.current = paginationlist.pageIndex;
    pageinfo.pageSize = paginationlist.pageSize;
    this.setState({
      pagination: pageinfo
    });
  }

  //分页改变事件
  _PaginChange = (page) => {
    if (this.props.model)
      this.props.model.setPageIndex(page);
    this.scrollRow = 0;
    this.scrollEndHeight = 0;
  }
  /*页大小改变*/
  onShowSizeChange = (current, size) => {
    if (this.props.model)
      this.props.model.setPageSize(size);
    this.scrollRow = 0;
    this.scrollEndHeight = 0;
  }
  formatter = (value) => {
    let _value = (value + '');
    let _valueArr = _value.split('.');
    if (_valueArr.length == 1) {
      return `${_value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    } else {
      _valueArr[0] = _valueArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${_valueArr.join('.')}`;
    }
  }
  _setFooter = (cellProps) => {
    const column = this.columns[cellProps.columnKey] || {};
    let { showAggregates, showCheckBox, showRowNo, showSubtotal } = this.GridProps;
    let { bNeedSum, bShowZero } = column || {};
    let footerTitle, footerCellStyle = { "padding": "8px 10px", "lineHeight": "14px", "text-align": "left", "width": cellProps.width };
    if (column.iAlign == 2) footerCellStyle['text-align'] = 'center';
    if (column.iAlign == 3) footerCellStyle['text-align'] = 'right';
    if (showAggregates == true) {
      footerTitle = (
        <div className="fixedDataTable-footer-title">
          <div className='public_fixedDataTableCell_cellContent subtotal subtotal_name'> 小计</div>
          <div className='public_fixedDataTableCell_cellContent aggregates aggregates_name'> 合计</div>
        </div>
      );
      // if (showCheckBox && this.props.tableTyep != 'rptTable') {
      if ((showCheckBox && !this.isGroup) || (showCheckBox && this.isGroup && this.state.groupShowCheckBox)) {
        if (cellProps.columnKey === 'CheckBox') return footerTitle;
      } else if (showRowNo) {
        if (cellProps.columnKey === 'GridRowNo') return footerTitle;
      } else if (this.ColIndexs[cellProps.columnKey] === 0) {
        return footerTitle;
      }
      if (bNeedSum) {
        // let data = this.dataList;
        let sum = 0, totalSum = 0;
        // if (data.length > 0) {
        //   for (let i = 0; i < data.length; i++) {
        //     let val = data[i][cellProps.columnKey];
        //     val = val ? val : 0;
        //     sum = sum + parseFloat(val);
        //   }
        // }
        let sumData = this.state.sumData;
        for (var key in sumData[0]) {
          if (key === cellProps.columnKey) {
            totalSum = sumData[0][key];
          }
        }
        if (!cb.utils.isEmpty(this.state.subtotalData[cellProps.columnKey])) {
          sum = this.state.subtotalData[cellProps.columnKey];
          sum = this._getDecimal(this.columns[cellProps.columnKey], sum);
        }
        totalSum = this._getDecimal(this.columns[cellProps.columnKey], totalSum);
        if (!bShowZero) {
          if (Number(sum) === 0) sum = '';
          if (Number(totalSum) === 0) totalSum = '';
        }
        return (
          <div className="fixedDataTable-footer-title">
            <div className='public_fixedDataTableCell_cellContent subtotal'>
              <Cell style={{ "height": this.props.footerHeigh || 35 }}>
                <div style={footerCellStyle} className="textCol" >
                  {sum}
                </div>
              </Cell>
            </div>
            <div className='public_fixedDataTableCell_cellContent aggregates'>
              <Cell style={{ "height": this.props.footerHeigh || 35 }}>
                <div style={footerCellStyle} className="textCol" >
                  {totalSum}
                </div>
              </Cell>
            </div>
          </div>
        )
      } else {
        return (
          <div className="fixedDataTable-footer-title">
            <div className='public_fixedDataTableCell_cellContent subtotal'>
              <Cell style={{ "height": this.props.footerHeigh || 35 }}>
                <div style={footerCellStyle} className="textCol" >
                </div>
              </Cell>
            </div>
            <div className='public_fixedDataTableCell_cellContent aggregates'>
              <Cell style={{ "height": this.props.footerHeigh || 35 }}>
                <div style={footerCellStyle} className="textCol" >
                </div>
              </Cell>
            </div>
          </div>
        )
      }
    } else if (showAggregates == 'local') {
      footerTitle = (
        <div className="fixedDataTable-footer-title">
          <div className='public_fixedDataTableCell_cellContent aggregates'> 合计</div>
        </div>
      );
      // if (showCheckBox && this.props.tableTyep != 'rptTable') {
      if (showCheckBox) {
        if (cellProps.columnKey === 'CheckBox') return footerTitle;
      } else if (showRowNo) {
        if (cellProps.columnKey === 'GridRowNo') return footerTitle;
      } else if (this.ColIndexs[cellProps.columnKey] === 0) {
        return footerTitle;
      }
      if (bNeedSum) {
        let sum = 0;
        if (!cb.utils.isEmpty(this.state.subtotalData[cellProps.columnKey])) {
          sum = this.state.subtotalData[cellProps.columnKey];
          sum = this._getDecimal(this.columns[cellProps.columnKey], sum);
        }
        if (!bShowZero && Number(sum) === 0) sum = '';
        return (
          <Cell style={{ "height": this.props.footerHeigh || 35 }}>
            <div style={footerCellStyle} className="textCol" >
              {sum}
            </div>
          </Cell>
        )
      }
    } else if (!showAggregates && showSubtotal) {
      footerTitle = (
        <div className="fixedDataTable-footer-title">
          <div className='public_fixedDataTableCell_cellContent subtotal subtotal_name'> 小计</div>
        </div>
      );
      if (showCheckBox) {
        if (cellProps.columnKey === 'CheckBox') return footerTitle;
      } else if (showRowNo) {
        if (cellProps.columnKey === 'GridRowNo') return footerTitle;
      } else if (this.ColIndexs[cellProps.columnKey] === 0) {
        return footerTitle;
      }
      if (bNeedSum) {
        let sum = 0;
        sum = this.state.subtotalData[cellProps.columnKey];
        sum = this._getDecimal(this.columns[cellProps.columnKey], sum);
        if (!bShowZero) {
          if (Number(sum) === 0) sum = '';
        }
        return (
          <div className="fixedDataTable-footer-title">
            <div className='public_fixedDataTableCell_cellContent subtotal'>
              <Cell style={{ "height": this.props.footerHeigh || 35 }}>
                <div style={footerCellStyle} className="textCol" >
                  {sum}
                </div>
              </Cell>
            </div>
          </div>
        )
      } else {
        return (
          <div className="fixedDataTable-footer-title">
            <div className='public_fixedDataTableCell_cellContent subtotal'>
              <Cell style={{ "height": this.props.footerHeigh || 35 }}>
                <div style={footerCellStyle} className="textCol" >
                </div>
              </Cell>
            </div>
          </div>
        )
      }
    }
  }
  _getDecimal = (col, sum) => {
    let NumPoint = col.iNumPoint;
    /*谓词变量支持系统参数*/
    let cFormatData = col.cFormatData;
    try {
      if (!cFormatData || cFormatData == '') {
        cFormatData = {};
      } else {
        cFormatData = JSON.parse(cFormatData);
      }
    } catch (e) {
      console.error('数量/金额/单价，预制错误！');
    }
    let decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
    let controlType = col.cControlType ? col.cControlType.trim().toLocaleLowerCase() : '';
    if (controlType === 'money') {
      cFormatData.splitter = true
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option.amountofdecimal;
    } else if (controlType === 'price') {
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option.monovalentdecimal;
    } else if (controlType === 'inputnumber') {
      if (decimal)
        NumPoint = decimal;
      else
        if (!NumPoint || NumPoint == '') NumPoint = 0;

    } else {
      NumPoint = null;
    }
    if (controlType === 'money' || (cFormatData.decimal && cFormatData.decimal.indexOf("amountofdecimal"))) {
      cFormatData.splitter = true
    }
    if (!isNaN(sum) && NumPoint != null) {
      sum = Number(sum);
      sum = getRoundValue(sum, NumPoint);
      if (cFormatData.splitter) { // add 千分位
        sum = this.formatter(sum);
      }
    }
    return sum;
  }
  /*pageSize改变事件*/
  _pageSizeChange = (value) => {
    this.props.model.setPageSize(value * 1);
    this.scrollRow = 0;
    this.scrollEndHeight = 0;
  }
  setPage = (pagination, isPage) => {
    const { bLoadPagination, loadPageEnd } = this.state;
    if (isPage && pagination.total !== 0) {
      let sumData = this.state.sumData;
      let columns = this.columns;
      let showSums = [];
      if (sumData.length > 0) {
        for (var key in sumData[0]) {
          if (!columns[key]) continue;
          if (sumData[0][key] == 0) continue;
          showSums.push(
            <Col span={1} style={{ fontSize: '18px' }}>
              {columns[key].cCaption}：{sumData[0][key]}
            </Col>
          )
          if (showSums.length > 2) {
            break;
          }
        }
      }
      let selectOptions = [{ "value": 10, "text": 10 }, { "value": 20, "text": 20 }, { "value": 30, "text": 30 }, { "value": 40, "text": 40 }, { "value": 50, "text": 50 }];
      let selectOptionsControl = selectOptions.map((item, index) => {
        return <Select.Option key={item.value} text={item.text}>{item.text}</Select.Option>
      });
      // let pageCount = Math.ceil(pagination.total / pagination.pageSize);
      // if (pageCount == 1) return ''
      if (!bLoadPagination && !loadPageEnd) {
        return (
          <div className='pagination-new pagination-simple'>
            <span className={pagination.current == 1 ? 'disabled' : ''} onClick={e => this._PaginChange(pagination.current - 1)}><Icon type='left' /></span>
            <span onClick={e => this._PaginChange(pagination.current + 1)}><Icon type='right' /></span>
            <span className='newfanyezhankai' onClick={e => {
              this.props.model.getPageInfo();
              this.setState({ expandPagination: true });
            }}></span>
          </div>
        )
      } else {
        let pageSizeOptions = ['10', '20', '30', '50', '80', '100', '1000', '10000'];
        if (this.props.style && this.props.style.pageSizeOptions) {
          try {
            pageSizeOptions = this.props.style.pageSizeOptions.split(',');
          } catch (e) { }
        }
        return (
          <div className='pagination-new'>
            <Pagination showQuickJumper showSizeChanger pageSizeOptions={pageSizeOptions} showTotal={total => `共${total}条`} size="small" total={pagination.total} current={pagination.current} pageSize={pagination.pageSize} onShowSizeChange={this.onShowSizeChange} onChange={this._PaginChange} />
            {/* <span>共<i>{pageCount}</i>页</span> */}
          </div>
        );
      }
    }
  }
  //栏目设置————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  columnSetting = () => {
    // this.props.model.getTitleData(this.props.code);
    this.setState({
      popFlag: !this.state.popFlag,
      searchValue: "",
      isClear: false
    })
    this.props.model.columnSetting(this.props.code);
  }
  //排序
  // sortClick = (type, index) => {
  //   let { titleList, lockindex, sorttag, editag, searchValue, lockSort } = this.state;
  //   if (searchValue === "" && lockSort && titleList.length) {
  //     titleList.forEach(function (ele, index) {
  //       if (ele.id == lockSort) {
  //         lockindex = index
  //       }
  //     })
  //   }
  //   if (type == 'up' && index == 0) return;
  //   if (type == 'down' && index == titleList.length - 1) return;
  //   if (!editag) {
  //     let lastindex = _.findLastIndex(titleList, (obj) => {
  //       return obj.bFixed == true
  //     })
  //     if (lastindex > -1) {
  //       if (type == 'up' && index == lastindex + 1) return;
  //       if (type == 'down' && index == lastindex) return;
  //     }
  //   }
  //   else {
  //     if (type == 'up' && index == lockindex + 1 && sorttag == true) return;
  //     if (type == 'up' && index == lockindex && sorttag == false) return;
  //     if (type == 'down' && index == lockindex && sorttag == true) return;
  //     if (type == 'down' && index == lockindex - 1 && sorttag == false) return;
  //   }
  //   if (titleList[index] && titleList[index].bJointQuery) {
  //     cb.utils.alert('关键字段不允许移动！', 'warning');
  //     return
  //   }
  //   let pre = cb.utils.extend(true, {}, titleList[index - 1]);
  //   let next = cb.utils.extend(true, {}, titleList[index + 1]);
  //   let now = cb.utils.extend(true, {}, titleList[index]);
  //   let preOrder = pre.iOrder;
  //   let nextOrder = next.iOrder;
  //   let nowOrder = now.iOrder;
  //   if (type == 'up') {
  //     this.sort = "up";
  //     // let preOrder = now.iOrder - 1;
  //     // if (!pre.iOrder) return;
  //     // if (pre.iOrder == preOrder) {
  //     //   pre.iOrder = preOrder + 1;
  //     // } else {
  //     //   titleList.forEach(function (ele) {
  //     //     if (preOrder == ele.iOrder) {
  //     //       ele.iOrder = preOrder + 1;
  //     //       return;
  //     //     }
  //     //   });
  //     // }
  //     // now.iOrder = preOrder;
  //     titleList[index] = pre;
  //     titleList[index].iOrder = nowOrder;
  //     titleList[index - 1] = now;
  //     titleList[index - 1].iOrder = preOrder;
  //   } else {
  //     this.sort = "down";
  //     // let nextOrder = now.iOrder + 1;
  //     // if (!next.iOrder) return;
  //     // if (next.iOrder == nextOrder) {
  //     //   next.iOrder = nextOrder - 1;
  //     // } else {
  //     //   titleList.forEach(function (ele) {
  //     //     if (nextOrder == ele.iOrder) {
  //     //       ele.iOrder = nextOrder - 1;
  //     //       return;
  //     //     }
  //     //   });
  //     // }
  //     // now.iOrder == nextOrder;
  //     titleList[index] = next;
  //     titleList[index].iOrder = nowOrder;
  //     titleList[index + 1] = now;
  //     titleList[index + 1].iOrder = nextOrder;
  //   }
  //   this.setState({
  //     titleList,
  //     lockSort: null,
  //     lockindex
  //   });
  // }
  setTitle = (titleList) => {
    this.setState({
      titleList
    });
  }
  setColumnByTtile = (columns) => {
    this.columns = columns;
    let columnset = this.RemodelingColumn(this.dataList, columns);
    this.setState({ columnset });
  }
  getSettingContent = () => {
    let { titleList, Unlock, lockindex, editag, searchValue, _titleList, searchtag, lockSort } = this.state;
    let Newlist = [], copyNewList = [], copyNewList1 = [];
    let noSort = false;
    let Newlocksort = [];
    let titileItem = [];
    titleList.forEach(ele => {
      if (ele.bFixed === 1 || ele.bFixed === true) {
        copyNewList1.push(ele)
      }
      else {
        copyNewList.push(ele)
      }
    })
    Newlist = copyNewList1.concat(copyNewList)
    if (searchValue != "") {
      Newlist = [];
      titleList.map(ele => {
        let elementText = ele.cShowCaption || ele.cCaption;
        if (elementText.indexOf(searchValue) > -1) {
          Newlist.push(ele)
        }
      });
    }
    else {
      noSort = false
    }
    if (Newlist.length <= 0) {
      titileItem = (<span className="haveno_search">暂无搜索结果~</span>)
      return this.returnContent(titileItem)
    }
    Newlist.forEach(function (element, index) {
      //  lockSort =Newlist[index].id
      Newlocksort.push(element.id)
      let item, lockitem;
      let bShowPop = element.bShowPop ? element.bShowPop : false;
      let showLockitem = true;
      let showUnlock = (element.bFixed === 1 || element.bFixed === true) ? true : false;
      if (searchValue != "") { showLockitem = false }
      if (!element.bHidden) {
        element.bShowIt = element.bShowIt ? true : false
        lockitem = showLockitem ? (showUnlock ?
          <span className="unlock" style={{ borderWidth: 0 }} onClick={() => this.unlockClick(index, Newlocksort, noSort)}><Icon type="dongjie"></Icon></span>
          :
          <span className="lock" style={{ borderWidth: 0 }} onClick={() => this.lockClick(index, Newlocksort, noSort)}><Icon type="weidongjie" /></span>
        ) : <span></span>
        item = (
          <Row key={uniqueId()} data-id={element.id} style={{ minHeight: "25px" }}
            className={showUnlock ? "lock_disable" : "unlock_able"}
          >

            <div className='pull-left' title={element.cShowCaption}>
              <Icon type="tuodong" />
              <Checkbox checked={element.bShowIt} onChange={(e) => this.onChecked(e, element, index)}>{element.cShowCaption || element.cCaption}</Checkbox>
            </div>
            <div className='pull-right'>
              {/* <Button style={{ borderWidth: 0, display: noSort == true ? 'none' : 'block' }} icon="arrow-up" onClick={() => this.sortClick('up', index)}></Button>
                <Button style={{ borderWidth: 0, display: noSort == true ? 'none' : 'block' }} icon="arrow-down" onClick={() => this.sortClick('down', index)}></Button> */}
              {lockitem}
            </div>
          </Row>
        )
        titileItem.push(item);
      }
    }, this);
    return this.returnContent(titileItem)
  }
  returnContent(titileItem) {
    let buttonClass = 'filter-btn-fixed';
    let { searchValue, isClear } = this.state;
    let clearValue = isClear ? <Icon type="close-circle" onClick={() => this.emitEmpty()} /> : null;
    let settingContent = (
      <div className={buttonClass} style={{ overflow: "auto", height: "298px" }}>

        <div className='filter-txt filter-table'>
          <Search value={searchValue} onChange={(e) => this.onSearchChange(e)} className="search_name" />
          {clearValue}
          <div className="search_scroll">
            <Sortable
              tag="div"
              options={{
                group: {
                  name: 'shared',
                  pull: false,
                  put: false
                },
                animation: 150,
                ghostClass: 'blue-background-class',
                scroll: true,
                scrollSensitivity: 10,
                scrollSpeed: 30
              }}
              onChange={(evl) => {
                this.dragOrder(evl)
              }}
            >
              {titileItem}
            </Sortable>

          </div>

        </div>
        <div className='filter-btn-1'>
          <Button type={"primary"} size="small" onClick={() => this.buttonClick('save')}>保存</Button>
          <Button type={"default"} size="small" onClick={() => this.buttonClick('cancel')}>取消</Button>
        </div>
      </div>
    );
    return settingContent;
  }
  dragOrder(evl) {
    console.log(evl)
    let { titleList, lockindex } = this.state;
    let copyDrag = [];
    const listLength = titleList.length;
    let filterData = titleList.filter(ele => ele.bFixed === 1 || ele.bFixed === true).length
    lockindex = filterData >= 1 ? filterData - 1 : -1
    for (let j = 0; j < listLength; j++) {
      for (let i = 0; i < listLength; i++) {
        if (titleList[i].id == evl[j]) {
          copyDrag.push(titleList[i])
          break;
        }
        if (evl.filter(item => item == titleList[i].id).length == 0) {
          let _index = _.findIndex(copyDrag, (obj) => {
            return obj.id === titleList[i].id
          })
          if (_index < 0) {
            copyDrag.push(titleList[i])
          }
        }
      }
    }
    copyDrag.forEach((ele, index) => {
      if (index <= lockindex) {
        ele.bFixed = 1
      }
      else {
        ele.bFixed = 0
      }
    })
    this.setState({ titleList: copyDrag })
  }
  /*搜索框改变*/
  onSearchChange = (e) => {
    let value = e.target.value;
    let isClear = value ? true : false;
    this.setState({ searchValue: value, isClear: isClear })
  }
  //清空搜索框
  emitEmpty = () => {
    let { isClear, lockindex } = this.state;
    let value = '';
    isClear = value ? true : false;
    this.setState({ isClear, searchValue: '' })
  }
  unlockClick = (index, Newlocksort, noSort) => {
    let { titleList } = this.state;
    let lockSort = noSort ? Newlocksort[index] : null;
    let _index = findIndex(titleList, obj => {
      return obj.id === Newlocksort[index]
    })
    if (_index > -1) {
      titleList.forEach((ele, index) => {
        if (index < _index) {
          ele.bFixed = 1
        }
        else {
          ele.bFixed = 0
        }
      })
      this.setState({ Unlock: false, lockindex: _index, sorttag: false, editag: true, lockSort: lockSort, titleList })
    }
  }
  lockClick = (index, Newlocksort, noSort) => {
    let { titleList } = this.state;
    let lockSort = noSort ? Newlocksort[index] : null;
    let _index = findIndex(titleList, obj => {
      return obj.id === Newlocksort[index]
    })
    if (_index > -1) {
      titleList.forEach((ele, index) => {
        if (index <= _index) {
          ele.bFixed = 1
        }
        else {
          ele.bFixed = 0
        }
      })
      this.setState({ Unlock: true, lockindex: _index, sorttag: true, editag: true, lockSort: lockSort, titleList })
    }
  }
  onChecked = (e, element, index) => {
    let { titleList, searchValue } = this.state;
    let Newlist = [].concat(titleList)
    if (searchValue != "") {
      Newlist = [];
      titleList.map(ele => {
        let elementText = ele.cShowCaption || ele.cCaption;
        if (elementText.indexOf(searchValue) > -1) {
          Newlist.push(ele)
        }
      });
    }
    let checked = e.target.checked;
    let id = element.id;
    let showTitleLen = this.getShowTitleLen(titleList);
    if (showTitleLen < 2 && !checked) {
      cb.utils.alert('至少保留一个显示列！', 'warning');
      return
    }
    if (Newlist[index].bJointQuery) {
      cb.utils.alert('关联字段不允许修改！', 'warning');
      return
    }
    if (checked) {
      titleList.map(item => {
        if (item.id == id) {
          item.bShowIt = 1
        }
      })

    } else {
      titleList.map(item => {
        if (item.id == id) {
          item.bShowIt = 0
        }
      })
    }
    this.setState({ titleList })

  }
  getShowTitleLen = (titleList) => {
    let len = 0;
    titleList.map(item => {
      if (item.bShowIt == 1)
        len = len + 1;
    })
    return len;
  }
  buttonClick = (type) => {
    if (type == 'save') {
      let newTitleList = [];
      var index = 1;
      this.state.titleList.map(title => {
        delete title.cFieldName;
        title.iOrder = index;
        index++;
        newTitleList.push(title);
      });
      this.props.model.setTitleData(newTitleList);
    }
    this.setState({
      popFlag: false,
      searchValue: "",
      _titleList: []
    });
  }
  onRowMouseEnter = (e, index) => {
    if (!this.action.controls) return
    if (this.fixedTable && this.fixedTable.state && this.fixedTable.state.isColumnResizing) return;
    this.selectIndex = index;
    this.mouseEnterClass = e.target.className;
    let showAction = this.state.showAction;
    this.showActionIndex = index;
    showAction[index] = true;
    this.scrollRow = index;
    this.setState({
      showAction
    });
  }
  onRowMouseLeave = (e, index) => {
    if (!this.action.controls) return
    if (this.fixedTable && this.fixedTable.state && this.fixedTable.state.isColumnResizing) return;
    const actionParent = new cb.dom(e.relatedTarget).parents('.acticonCell');
    const actionParent1 = new cb.dom(e.relatedTarget).parents('.ant-popover');
    if (actionParent.length || actionParent1.length) return;
    this.selectIndex = -1;
    this.showActionIndex = -1;
    let showAction = this.state.showAction;
    showAction[index] = false;
    this.setState({
      showAction
    });
  }
  getColumnSetting = () => {
    let hasSetting = (this.state.showColumnSetting && this.props.T2D_TableNum != "2D");
    if (hasSetting) {
      let settingContent = this.getSettingContent();
      let popFlag = this.state.popFlag;
      return (
        <div className="columnSetting" >
          <Popover overlayStyle={{ width: "240px" }} placement={"bottomRight"} content={settingContent} trigger={"click"} visible={popFlag} >
            <Button className="SettingBtn" type={"ghost"} size="small" icon='ellipsis' onClick={() => this.columnSetting()}></Button>
          </Popover>
        </div>
      );
    } else {
      return ''
    }
  }
  /*悬浮的action*/
  getActionControl = () => {
    return;
    if (!this.state.readOnly) return;/*编辑态不显示*/
    if (this.isScrolling) return;/*滚动时不显示*/
    if (this.props.noBrowseAction) return;/*浏览态不显示*/
    // if(!this.dataList[this.showActionIndex]) return;/*无数据时 不渲染*/

    let actionList = this.action.controls;
    let actionState = this.actionState;
    let actionControl = [], rowheight = this.rowheight;;
    let actionStyle = { "display": "none", "height": rowheight - 1 };
    let rowStyle = { "display": "flex", "alignItems": "center", "height": rowheight - 1 };
    let _id = this.dataList[this.showActionIndex] ? this.dataList[this.showActionIndex]._id : 0;
    if (actionList && actionList.length > 0) {
      if (this.state.showAction && this.state.showAction[this.showActionIndex]) {
        actionStyle.display = "block";
        let headerHeight = (this.headerHeight || 40);
        let initialTop = headerHeight + 8 + (rowheight - 40) / 2;
        actionStyle.top = initialTop + this.showActionIndex * rowheight - this.scrollEndHeight;
        if (actionStyle.top <= initialTop) {
          this.offsetType = 'top';
          this.offsetY = initialTop - actionStyle.top;
          this.scrollEndHeight = this.scrollEndHeight - this.offsetY;
          actionStyle.top = initialTop;
        } else if (actionStyle.top >= this.bodyHeight) {
          this.offsetType = 'end';
          this.offsetY = actionStyle.top - this.bodyHeight - (initialTop - headerHeight);
          if (this.offsetY > 0) {
            this.scrollEndHeight = this.scrollEndHeight + this.offsetY;
            actionStyle.top = this.bodyHeight + 8 - (rowheight - 40) / 2;
          } else {
            actionStyle.top = this.bodyHeight + 8 - (rowheight - 40) / 2 + this.offsetY;
          }
        }
        actionStyle.top = actionStyle.top - (rowheight - 26) / 2;
      }
      actionList.map(function (action) {
        const icon = action.iStyle === 1 ? null : '#icon-' + action.icon;
        const text = action.iStyle === 2 ? null : action.cShowCaption;

        if (actionState[_id] && actionState[_id][action.cItemName].visible) {
          if (action.cControlType != 'popbutton') {
            const extraProps = {};
            if (!action.popoverKey)
              extraProps.onClick = (e) => this.ActionClick(e, action);
            let temp_action = (
              <span key={action.cItemName}>
                <a className="table-list-btn" {...extraProps}>{text}</a>
              </span>
            );
            if (action.popoverKey) {
              const ComName = PopoverMap[action.popoverKey];
              if (ComName)
                temp_action = (
                  <ComName model={action.model} data={this.dataList[this.showActionIndex]}>
                    {temp_action}
                  </ComName>
                );
            }
            actionControl.push(temp_action);
          } else {
            const currentRow = this.dataList[this.showActionIndex];
            if (!currentRow) return;
            // actionControl.push(<CssProgress id={currentRow.id} text={text} cItemName={action.cItemName} icon={icon} />);
          }
        }
      }, this);
      let actionCellName = "acticonCell";
      if (this.props.model) {
        let selectRows = this.props.model.getSelectedRowIndexes();
        for (var i = 0; i < selectRows.length; i++) {
          let rowIndex = selectRows[i];
          if (this.selectIndex === rowIndex)
            actionCellName = actionCellName + ' actionCellSelect';
        }
      }
      let lookUpRowIndexes = this.lookUpRowIndexes;
      if (lookUpRowIndexes.length > 0) {
        lookUpRowIndexes.forEach(index => {
          if (this.showActionIndex == index)
            actionCellName = actionCellName + ' actionCellSelect';
        });
      }
      return (
        <div className={actionCellName} style={actionStyle}>
          <Row style={rowStyle}>{actionControl}</Row>
        </div>
      );
      // return '';
    }
  }
  ActionClick = (e, action) => {
    /*表单 报表设计器 行按钮*/
    if (this.props.noViewModel == true && this.props.onActionClick) {
      this.props.onActionClick(this.showActionIndex, action);
      return
    }
    if (this.actionClickTime) {
      let nowTime = new Date().valueOf();
      if (nowTime - this.actionClickTime < 1000) return;
      this.actionClickTime = nowTime;
    } else {
      this.actionClickTime = new Date().valueOf();
    }
    this.props.model.setFocusedRowIndex(this.showActionIndex);
    let viewModel = this.props.model.getParent();
    while (viewModel.getParent())
      viewModel = viewModel.getParent();
    let params = { index: this.showActionIndex, cItemName: action.cItemName }
    viewModel.get(action.cItemName).fireEvent('click', params);
    if (action.cItemName == 'btnDelete' || action.cItemName == 'btnDeleteRow') {
      this.selectIndex = -1;
      let showAction = this.state.showAction;
      showAction[this.showActionIndex] = false;
      this.setState({
        showAction
      });
    }
  }
  onScrollStart = () => {
    this.isScrolling = true;
    this.showActionIndex = -1;
  }
  onScrollEnd = (a, b, c) => {
    this.isScrolling = false;
    if (this.scrollEndHeight != b) {
      if (this.state.mergeCells) {
        try {
          let rowWrapper = this.fixedTable._divRef.getElementsByClassName('fixedDataTableRowLayout_rowWrapper');
          for (var i = 0; i < rowWrapper.length; i++) {
            let row = rowWrapper[i];
            let zIndex = row.style.transform.split(',')[1];
            zIndex = parseFloat(zIndex);
            if (row.getElementsByClassName('public_fixedDataTable_header').length > 0)
              zIndex = 999;
            if (row.style.zIndex != zIndex) {
              row.style.zIndex = zIndex > 0 ? zIndex : 0;
            }
          }
        } catch (e) {

        }
      }
    }
    this.scrollEndHeight = b;
    this.offsetY = 0;
    this.nowSetDataSource = false;
  }
  //悬浮按钮————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  rowHeightGetter = (index) => {
    if (this.hasSpecialCol) {
      let row = this.dataList[index];
      let maxRows = 0;
      this.specialCols && this.specialCols.map(speCol => {
        let cStyle = this.columns[speCol].cStyle;
        try {
          cStyle = JSON.parse(cStyle);
        } catch (e) {
          cb.utils.alert('specialcom  cstyle预制错误！');
          return;
        }
        let specialDataSource = cStyle.dataSource;
        if (row[specialDataSource] && row[specialDataSource].length > maxRows)
          maxRows = row[specialDataSource].length
      });
      if (maxRows <= 1) return this.rowheight;
      return 30 * maxRows;
    } else {
      return this.rowheight;
    }
  }
  getEmptyData = () => {
    let data = this.dataList;
    if (data.length) return;
    const text = this.state.showSearch ? '搜索无结果' : '暂时没有数据哦~';
    const icon = this.props.emptyIcon || 'nodata';
    return <div className='table-nodata'><SvgIcon type={icon} />{text}</div>
  }
  render() {
    // return <ListAreaMap model={this.props.model} cStyle={this.props.style} />;
    // return <HotAreaMapDisplay model={this.props.model} cStyle={{}} mapConfig={{}} meta={this.props.meta} width={888} height={888} />;//
    // return <HotAreaMapDesign model={this.props.model} cStyle={this.props.style} />;
    // return <HotAreaMapDesignContainer config={this.props.config} />;
    let pagination = this.setPage(this.state.pagination, this.GridProps.isPagination);
    let footerHeight = 0, visible = this.state.visible, showAggregates = this.GridProps.showAggregates, showSubtotal = this.GridProps.showSubtotal;
    let columnSetting = this.getColumnSetting();
    let overflowY = 'auto';
    if (showAggregates == true) {
      footerHeight = this.props.footerHeigh || (this.props.rowHeight || 35) * 2;
    } else if (showAggregates == 'local') {
      footerHeight = this.props.footerHeigh || (this.props.rowHeight || 35);
    } else if (!showAggregates && showSubtotal) {
      footerHeight = this.props.footerHeigh || (this.props.rowHeight || 35);
    }
    let style = this.state.style || {};
    let gridClassName = '';
    let scrollXWidth = (this.totalWidth > (this.props.width || 1100) ? 17 : 2);
    /*不记得为什么加这句了 但好像不符合逻辑  暂时去掉*/
    // if (!this.GridProps.isPagination) scrollXWidth = 17;
    if (style.rowheight) this.rowheight = parseFloat(style.rowheight);
    if (visible) gridClassName = 'hide';
    let actionControl = this.getActionControl();
    let emptyData = this.getEmptyData();

    let gridHeight = 0;
    if (this.props.maxRowCount) {
      if (this.props.height === 0) {
        gridHeight = this.rowheight * this.props.maxRowCount + (this.headerHeight || 40) + scrollXWidth;
        if (this.GridProps.isPagination) gridHeight = gridHeight - 58;
      } else {
        gridHeight = this.rowheight * this.props.maxRowCount + (this.headerHeight || 40) + footerHeight + scrollXWidth;
        if (this.GridProps.isPagination) {
          if (gridHeight > (this.props.height - 58)) {
            gridHeight = this.props.height - 58;
          }
        } else {
          if (gridHeight > this.props.height) {
            gridHeight = this.props.height;
          }
        }
      }
    }
    /*单据表体高度*/
    else {
      let len = 10;
      if (this.dataList.length < 10) len = this.dataList.length;
      // if (this.props.tableClass == 'rptTable') scrollXWidth = 2;
      gridHeight = this.rowheight * len + (this.headerHeight || 40) + (this.groupHeaderHeight || 0) + footerHeight + scrollXWidth;
    }

    if (emptyData) gridHeight = 200 + footerHeight;
    // if (this.props.tableClass == 'rptTable') gridHeight += footerHeight;
    if (gridHeight < 230 && this.dataList.length == 0) gridHeight = 230;

    let tableClass = this.props.tableClass ? this.props.tableClass : 'listTable';
    if (tableClass == 'BillDesign' || tableClass == 'ReportDesign') {
      tableClass = 'listTable';
      gridHeight = this.props.height;
    }
    if (this.state.mergeCells) tableClass = 'mergeTable';
    // if (this.state.mergeCells && this.state.mergePosition == 'center') tableClass = 'mergeTable';

    /*交班--根据传入rowcount  动态渲染高度*/
    const calcHeightByRowCount = this.state.calcHeightByRowCount;
    if (calcHeightByRowCount) {
      gridHeight = this.rowheight * calcHeightByRowCount + (this.headerHeight || 40) + footerHeight + scrollXWidth;
      if (gridHeight < 170) gridHeight = 170;
    }
    if (this.dataList.length == 0) {
      footerHeight = 0;
    }
    if (this.state.readOnly)
      tableClass = tableClass + " readOnlyTable";
    this.bodyHeight = gridHeight - (this.headerHeight || 40) - footerHeight - scrollXWidth;
    if (this.props.tableTyep == 'rptTable') {
      let tableWidth = this.props.width || 1100;
      if (this.colsWidth > tableWidth)
        gridHeight += 15;
    }
    if (this.hasSpecialCol) {
      gridHeight = this.rowheight * 10 + (this.headerHeight || 40) + (this.groupHeaderHeight || 0) + footerHeight + scrollXWidth;
    }
    if (this.props.listHeaderHeight) {
      const cacheHeight = gridHeight;
      gridHeight = this.props.height;
      if (this.GridProps.isPagination) gridHeight -= 58;
      // if (this.props.tableClass == 'rptTable') scrollXWidth = 2;
      let gHeight = this.rowheight * this.dataList.length + (this.headerHeight || 40) + (this.groupHeaderHeight || 0) + footerHeight + scrollXWidth;
      if (gridHeight > gHeight || gridHeight < 0) gridHeight = gHeight;
      /*最小高度  自适应后小于170 且表体数据总高度超过170  取表体数据高度 最高10行*/
      if (gridHeight < 170) {
        if (gHeight > 170)
          gridHeight = this.dataList.length <= 10 ? gHeight : this.rowheight * 10 + (this.headerHeight || 40) + (this.groupHeaderHeight || 0) + footerHeight + scrollXWidth;
        else
          gridHeight = (cacheHeight > 170) ? 170 : cacheHeight;
      }
      if (this.dataList.length == 0) gridHeight = 230;
    }
    if (this.props.autoHeight === false) {
      gridHeight = this.props.height;
      if (this.GridProps.isPagination) gridHeight -= 58;
    }

    return (
      <div ref="table" id={this.tableGuid || ''} className={`meta-table ${gridClassName}` + ' ' + tableClass}>
        <Row>
          {columnSetting}
          {actionControl}
          <Table ref="fixedtable"
            rowHeight={this.rowheight}
            overflowY={overflowY}
            overflowX={'auto'}
            onScrollStart={this.onScrollStart}
            onScrollEnd={this.onScrollEnd}
            headerHeight={this.headerHeight || 40}
            groupHeaderHeight={this.groupHeaderHeight || 0}
            footerHeight={footerHeight}
            rowsCount={this.dataList.length}
            width={this.props.width || 1100}
            height={gridHeight}
            onColumnResizeEndCallback={this._onColumnResizeEndCallback}
            isColumnResizing={false}
            // onColumnReorderEndCallback={this._onColumnReorderEndCallback}
            // isColumnReordering={false}
            onRowClick={this._onRowClick}
            // onRowDoubleClick={this._onRowDoubleClick}
            rowClassNameGetter={this.rowClassNameGetter}
            rowHeightGetter={this.rowHeightGetter}
            scrollToRow={this.scrollRow}
            scrollToColumn={this.scrollCol}
            onRowMouseEnter={this.onRowMouseEnter}
            onRowMouseLeave={this.onRowMouseLeave}
            onVerticalScroll={this.onVerticalScroll}
            touchScrollEnabled
          // showScrollbarY={false}
          >
            {this.state.columnset}
          </Table>
          {emptyData}
        </Row>
        <Row>
          {pagination}
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/table.jsx